<template>
    <DefaultLayout>
        <ProductManagement/>
    </DefaultLayout>
</template>

<script>
import ProductManagement from "@/views/Dashboard/Product/ProductManagement.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

export default {
    data() {
        return {
        };
    },
    components: {
        ProductManagement,
        DefaultLayout
    },
    mounted() {
    },
    computed: {
        
    },
    methods: {
        

    },
};
</script>

<style>
</style>
